// 入金・精算
const PAYMENT_TYPE_PARAM_KEY = 'deviceType';
const PAYOUT_TYPE_PARAM_KEY = 'payoutType';

// お知らせ関連
const AUTHOR_PARAM_KEY = 'author';

// レース関連
const RACE_TYPE_PARAM_KEY = 'type';
const VELODROME_CODE_PARAM_KEY = 'velodromeCode';
const ONLY_HIT_PARAM_KEY = 'onlyHit';
const BET_TYPE_CODE_PARAM_KEY = 'betTypeCode';
const HELD_DATE_PARAM_KEY = 'heldDate';

// 友達招待
const INVITER_PARAM_KEY = 'inviter';

// その他
const DATE_PARAM_KEY = 'date';
const CAMPAIGN_ID_PARAM_KEY = 'campaignid';

export {
  AUTHOR_PARAM_KEY,
  BET_TYPE_CODE_PARAM_KEY,
  CAMPAIGN_ID_PARAM_KEY,
  DATE_PARAM_KEY,
  HELD_DATE_PARAM_KEY,
  INVITER_PARAM_KEY,
  ONLY_HIT_PARAM_KEY,
  PAYMENT_TYPE_PARAM_KEY,
  PAYOUT_TYPE_PARAM_KEY,
  RACE_TYPE_PARAM_KEY,
  VELODROME_CODE_PARAM_KEY,
};
